window.Graphics= {
	chart : {},
	create : function(option) {

		var params = {
			chart	: {
				renderTo		: option.container ? option.container : '',
				height			: option.height ? option.height : '',
				type			: option.type ? option.type : '',
				width			: option.width ? option.width : '',
				backgroundColor : option.background ? option.background  : '',
				zoomType		: 'x'
			},
			colors	: option.colors ? option.colors : '',
			title	: {
				text : option.title ? option.title : ''
			},
			xAxis	: {
				title: {
					text: option.xTitle ? option.xTitle : ''
				},
				labels: {
					style: {
						fontSize: '7px'
					},
					step : option.xAxisStep ? option.xAxisStep : 1
				},
				categories: option.xAxis ? option.xAxis : ''
			},
			yAxis: {
				labels: {
					style: {
						fontSize	: '9px'
					}
				},
				title: {
					text	: option.yTitle ? option.yTitle : ''
				}
			},
			legend: {
				enabled			: option.legend ? option.legend : true,
				backgroundColor	: option.legendBg ? option.legendBg : null,
				borderColor		: option.legendBorder ? option.legendBorder : null,
				align			: option.legendHAlign ? option.legendHAlign : 'center',
				verticalAlign	: option.legendVAlign ? option.legendVAlign : 'bottom',
				width			: option.legendWidth ? option.legendWidth : null,
				x				: option.legendX ? option.legendX : 0,
				layout			: "vertical",
				borderRadius	: 0
			},
			credits: {
				enabled:false
			},
			series:  option.data ? option.data : '',
			tooltip: {
				formatter: function() {
					var numformat 	= NumberFormat.loadFromInputs('num_');

					if('pie'==option.type){
						return '<b>'+this.point.name+'</b> : '+this.point.m;
					}else{
						var hasCurrency = this.series.userOptions.hasCurrency;
						var method 		= (hasCurrency == undefined || hasCurrency == 'N') ? 'formatToDisplay' : 'formatToDisplayWithCurrency';

						return ""+ Loc.g("Période")+" : "+this.x +"<br/>"
							+this.series.name + " : "
							+NumberFormat[method](this.y, numformat);
					}
				}
			},
			plotOptions: {
				pie: {
					allowPointSelect: true,
					cursor: 'pointer',
					dataLabels: {
						enabled: false
					},
					showInLegend: false
				},
				line: {
					marker: {
						enabled: false,
						lineWidth : 1,
						states: {
							hover: {
								enabled: true,
								symbol: 'circle',
								radius: 1,
								lineWidth: 1
							}
						}   
					}
				}
			}
		};
		
		

//		if('pie'!=option.type)
//		{
//			delete params['plotOptions'];
//			delete params['tooltip'];
//		}

		Graphics.chart = new Highcharts.Chart(params);

	}
};